import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopGSP = dynamic(() => import("../../components/software-partners/GSP/DesktopGSP"), {
    loading: () => <Loading />,
});

const MobileGSP = dynamic(() => import("../../components/software-partners/GSP/MobileGSP"), {
    loading: () => <Loading />,
});

const gspIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QueueBuster POS with GSP Integration | Simplify GST Compliance</title>
                <meta name="description" content="Integrate QueueBuster POS with ADSR to optimize your business operations. Streamline billing, inventory, and reporting with this advanced solution." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/gsp" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/gsp" hrefLang="en-us" />
                <meta property="og:title" content="QueueBuster POS + ADSR Integration: Smarter Business Management" />
                <meta property="og:description" content="Experience seamless operations with QueueBuster POS and ADSR integration. Simplify billing, inventory tracking, and reporting for better business efficiency." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/gsp.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/gsp" />
            </Head>
            {mobileView ? <MobileGSP /> : <DesktopGSP />}
        </>
    )
}

export default gspIntegration